import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { Checkbox } from "../Checkbox";

export type HideFutureConfig = {
	checked: boolean;
	onToggle: () => void;
	label: string;
};

type Props = {
	config?: HideFutureConfig;
};

export const HideFutureCheckbox = ({ config }: Props) => {
	const theme = useAppTheme();

	if (!config) {
		return null;
	}

	return (
		<Box flexDirection="row" alignItems="center" flexShrink={1}>
			<Checkbox
				status={config.checked ? "checked" : "unchecked"}
				onPress={config.onToggle}
			/>
			<Text
				variant="bodySmall"
				onPress={config.onToggle}
				style={{
					color: theme.colors.onSurfaceVariant,
					flexShrink: 1,
				}}
			>
				{config.label}
			</Text>
		</Box>
	);
};
